import { createContext } from "react";

export const SrfContext = createContext(undefined);
  
  